import { makeAutoObservable } from 'mobx'
import { WorkScheduleRequest } from '../requests/WorkScheduleRequest'
// Request

class WorkScheduleStore {
  /** Work schedule list */
  workScheduleList = []

  /** Work schedule detail */
  workScheduleDetail = {}

  constructor() {
    makeAutoObservable(this)
  }
  /** Get work schedule */
  getWorkSchedule = async (fromDate, toDate) => {
    const response = await WorkScheduleRequest.getWorkSchedule(fromDate, toDate)
    this.workScheduleList = response.data
    return response.data
  }

  /** Get work schedule */
  getPublicWorkSchedule = async (fromDate, toDate) => {
    const response = await WorkScheduleRequest.getPublicWorkSchedule(
      fromDate,
      toDate
    )
    return response.data
  }

  /** Get work schedule detail */
  getWorkScheduleDetail = scheduleCode => {
    return new Promise((resolve, reject) => {
      WorkScheduleRequest.getWorkScheduleDetail(scheduleCode)
        .then(response => {
          this.workScheduleDetail = response.data
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** Update work schedule */
  updateWorkSchedule = (scheduleCode, formData) => {
    return new Promise((resolve, reject) => {
      WorkScheduleRequest.updateWorkSchedule(scheduleCode, formData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** Update work schedule detail */
  updateWorkScheduleDetail = detail => {
    this.workScheduleDetail = detail
  }

  /** Create work schedule */
  createWorkSchedule = submitData => {
    return new Promise((resolve, reject) => {
      WorkScheduleRequest.createWorkSchedule(submitData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** Delete work schedule */
  delete = scheduleCode => {
    return new Promise((resolve, reject) => {
      WorkScheduleRequest.delete(scheduleCode)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  /** Clear schedule */
  clearWorkSchedule = () => {
    this.workScheduleList.length = 0
  }

  /** Clear schedule detail */
  clearWorkScheduleDetail = () => {
    this.workScheduleDetail = {}
  }
}
const workScheduleStore = new WorkScheduleStore()

export default workScheduleStore
